import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type KnowledgeAssetsQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.ContentFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type KnowledgeAssetsQuery = { contents: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, status: Types.ResourceStatusEnum, approvalStatus?: Types.ContentApprovalStatusEnum | null, knowledgeAssetSubTypeVariant?: Types.KnowledgeAssetSubTypeVariantEnum | null, industries?: Array<Types.KnowledgeAssetIndustryEnum> | null, description?: string | null, knowledgeAssetSubType?: Types.KnowledgeAssetSubTypeEnum | null, cover?: { url?: string | null } | null, childKnowledgeAssets: Array<{ id: string, name: string, knowledgeAssetSubType?: Types.KnowledgeAssetSubTypeEnum | null, cover?: { url?: string | null } | null }> } | { id: string, name: string, type: Types.ResourceTypeEnum, duration: number, description?: string | null, cover?: { url?: string | null } | null } | {} }> | null } };


export const KnowledgeAssetsDocument = /*#__PURE__*/ gql`
    query knowledgeAssets($sort: [SortType!], $filters: ContentFilters, $after: String, $first: Float) {
  contents(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ... on KnowledgeAssetContentType {
          id
          name
          status
          approvalStatus
          knowledgeAssetSubTypeVariant
          industries
          description
          cover {
            url
          }
          childKnowledgeAssets {
            id
            name
            knowledgeAssetSubType
            cover {
              url
            }
          }
          knowledgeAssetSubType
        }
        ... on PathContentType {
          id
          name
          type
          duration
          description
          cover {
            url
          }
        }
      }
    }
  }
}
    `;

export function useKnowledgeAssetsQuery(options?: Omit<Urql.UseQueryArgs<KnowledgeAssetsQueryVariables>, 'query'>) {
  return Urql.useQuery<KnowledgeAssetsQuery, KnowledgeAssetsQueryVariables>({ query: KnowledgeAssetsDocument, ...options });
};